// extracted by mini-css-extract-plugin
export default {"container":"styles_container__a88ri","spinnerWrapper":"styles_spinnerWrapper__+QcJS"};